import { Check, ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";
import { activityIndicatorStyles as s } from "./ActivityIndicator.styles";
import { AskTigerSparkle } from "./AskTigerSparkle";
import { useActivitySteps } from "./useActivitySteps";

export function ActivityIndicator() {
  const steps = useActivitySteps();
  const [expanded, setExpanded] = useState(false);

  if (steps.length === 0) return null;

  const active = steps.find((step) => step.status === "running");
  const summaryLabel = active
    ? active.title
    : `Completed ${steps.length} step${steps.length === 1 ? "" : "s"}`;

  return (
    <div className={s.root} role="status">
      <button
        type="button"
        onClick={() => setExpanded((value) => !value)}
        aria-expanded={expanded}
        className={s.summary}
      >
        {active ? <AskTigerSparkle size={14} className={s.summarySparkle} /> : null}
        <span className={s.summaryText}>
          <span className={s.summaryLabel}>{summaryLabel}</span>
          {active?.detail ? <span className={s.summaryDetail}>{active.detail}</span> : null}
        </span>
        {expanded ? (
          <ChevronUp className={s.chevron} aria-hidden="true" />
        ) : (
          <ChevronDown className={s.chevron} aria-hidden="true" />
        )}
      </button>
      {expanded ? (
        <ul className={s.list}>
          {steps.map((step) => (
            <li key={step.id} className={s.step}>
              <span className={s.stepIcon} aria-hidden="true">
                {step.status === "done" ? (
                  <Check size={12} className={s.check} />
                ) : (
                  <AskTigerSparkle size={12} className={s.stepSparkle} />
                )}
              </span>
              <span className={s.stepText}>
                <span className={s.stepLabel}>{step.title}</span>
                {step.detail ? <span className={s.stepDetail}>{step.detail}</span> : null}
              </span>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
